<template>
    <div>
        <v-container fluid>
            <v-layout justify-end>
                <v-flex xs3 md1>
                    <v-card dark tile flat color="cyan">
                        <v-card-text>
                            <b>Idioma:</b>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs2 md1>
                    <v-card dark tile flat color="cyan">
                        <v-card-text>
                            <select class="LanguageSwitcher"
                                    name="language"
                                    @change="changeLanguage">

                                <option v-for="lang in supportedLanguages"
                                        :key="lang"
                                        :selected="isCurrentLanguage(lang)"
                                        :class="{ 'is-selected': isCurrentLanguage(lang) }"
                                        :value="lang"
                                >
                                    {{lang}}
                                </option>
                            </select></v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
    import {Trans} from '../plugins/Translation'

    export default {
        data() {
            return {
                selected: ''
            }
        },
        computed: {
            supportedLanguages() {
                return Trans.supportedLanguages
            },
            currentLanguage() {
                return Trans.currentLanguage
            }
        },
        methods: {
            changeLanguage(e) {
                const lang = e.target.value;


                const to = this.$router.resolve({params: {lang}});
                return Trans.changeLanguage(lang).then(() => {
                    this.$router.push(to.location);
                });

            },
            changeLanguageCreated(lang) {
                const to = this.$router.resolve({params: {lang}});
                return Trans.changeLanguage(lang).then(() => {
                    this.$router.push(to.location);
                });

            },
            isCurrentLanguage(lang) {
                return lang === this.currentLanguage
            }
        },
        created() {
            let lang = 'es';
            this.changeLanguageCreated(lang);
            setTimeout(() => {
                lang = 'cat';
                this.changeLanguageCreated(lang);
                this.$store.commit('changelanguageSwitcher', lang);
            }, 500);
        }
    }
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');

    *{
        font-family: 'Josefin Sans', sans-serif;
    }

</style>
